import { forwardRef, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import Svg from '../Svg';
import { CrossCircle } from '@/icons';

type InputTypes = 'text' | 'number' | 'password' | 'email' | 'tel';

export interface FormTextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  type?: InputTypes;
  placeholder?: string;
  inputClassName?: string;
  labelClassName?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  error?: {
    message?: string;
  };
}

const FormTextField = forwardRef<HTMLInputElement, FormTextFieldProps>(
  (
    {
      id,
      type = 'text',
      placeholder = '',
      inputClassName,
      startAdornment,
      endAdornment,
      maxLength,
      error,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <div aria-label={id} className={twMerge('space-y-1', className)}>
        <div className='relative'>
          {startAdornment}
          <input
            ref={ref}
            id={id}
            name={id}
            type={type}
            placeholder={placeholder}
            maxLength={maxLength}
            data-error={!!error?.message}
            {...rest}
            className={twMerge(
              'w-full text-base rounded-lg border-2 p-3 placeholder:text-gray-500/80 placeholder:text-sm',
              error ? 'border-red-500' : 'border-black/70',
              inputClassName
            )}
          />
          {endAdornment}
        </div>

        {error && error?.message && (
          <label
            htmlFor={id}
            className='flex items-center gap-x-1 text-xs text-error'>
            {id === 'pincode' && (
              <Svg
                className='rounded-full bg-[#D21212] stroke-white p-1'
                viewBox='15 10 10 20'>
                <CrossCircle />
              </Svg>
            )}
            {error.message}
          </label>
        )}
      </div>
    );
  }
);

FormTextField.displayName = 'FormTextField';

export default FormTextField;
